import { handleTextOverflow } from '@repo/ui/components/utilities';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { ButtonWrapper } from '../TeamButton/styles';

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  font-weight: ${themeStyle.fontSemiBold};
  line-height: 18px;

  ${handleTextOverflow}
`;

export const StyledButtonWrapper = styled(ButtonWrapper)`
  padding: ${(props) => props.theme.padding};
  height: ${(props) => props.theme.height};
  border: ${(props) => props.theme.border};
  font-size: ${(props) => props.theme.fontSize || themeStyle.fontSize12};
  color: ${(props) => props.theme.color || themeStyle.varInkMedium};
  background: ${(props) => props.theme.background};

  && path {
    fill: ${(props) => props.theme.color || themeStyle.varInkMedium};
  }

  &:hover {
    color: ${(props) => props.theme.colorHover};
    background: ${(props) => props.theme.backgroundHover};

    path {
      fill: ${(props) => props.theme.colorHover};
    }
  }
`;
